import React, { Component } from 'react';
import PropTypes from 'prop-types';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_bannerTop__1Qa53{\n    border-bottom: 1px solid #ccc;\n    background-color: white;\n}\n\n.styles_bannerBottom__2QXe9 {\n  position:fixed;\n  border-top: 1px solid #ccc;\n  bottom: 0;\n  width: 100%;\n  background-color: #ffffff;\n}\n\n.styles_bannerSticky__hwyBi{\n    position: sticky;\n    top: 0;\n}\n\n.styles_banner__23gks{\n  -webkit-touch-callout: none; \n    -webkit-user-select: none;\n     -khtml-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none; \n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    margin: 5px;\n}\n.styles_bannerClose__13k72{\n    padding: 2px;\n}\n.styles_bannerIcon__3zngJ{\n   width: 57px;\n   height: 57px;\n}\n.styles_bannerImage__BlwCo{\n    margin: 2px;\n}\n.styles_bannerContents__1I2FG{\n    width: 100%;\n    margin: 5px;\n}\n.styles_bannerTitle__iuPpp{\n    font-size: 16px;\n}\n\n.styles_bannerDescription__39j6e{\n    font-size: 12px;\n    font-weight: 200;\n}\n\n.styles_bannerStoreText__1swVN{\n    font-size: 12px;\n    font-weight: 200; \n}\n\n.styles_rating__q1Z27 {\n    unicode-bidi: bidi-override;\n  }\n  \n.styles_rating__q1Z27 > span {\n    display: inline-block;\n    position: relative;\n    width: 1.1em; \n    font-size: 12px;\n  }\n \n.styles_activeStar__9Qy4m{\n    content: \"\\2605\";\n    position: absolute;\n    left: 0;\n    color: gold;\n  }\n  \n  .styles_bannerButtonText__QoMgN {\n    border-radius: 5px;\n    padding: .5em;\n    text-decoration: none;\n  }\n  \n  .styles_bannerButton__nbEJS {\n    margin-top: 25px;\n    margin-left: 2%;\n  }";
var styles = {
  "bannerTop": "styles_bannerTop__1Qa53",
  "bannerBottom": "styles_bannerBottom__2QXe9",
  "bannerSticky": "styles_bannerSticky__hwyBi",
  "banner": "styles_banner__23gks",
  "bannerClose": "styles_bannerClose__13k72",
  "bannerIcon": "styles_bannerIcon__3zngJ",
  "bannerImage": "styles_bannerImage__BlwCo",
  "bannerContents": "styles_bannerContents__1I2FG",
  "bannerTitle": "styles_bannerTitle__iuPpp",
  "bannerDescription": "styles_bannerDescription__39j6e",
  "bannerStoreText": "styles_bannerStoreText__1swVN",
  "rating": "styles_rating__q1Z27",
  "activeStar": "styles_activeStar__9Qy4m",
  "bannerButtonText": "styles_bannerButtonText__QoMgN",
  "bannerButton": "styles_bannerButton__nbEJS"
};
styleInject(css);

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var MobileBanner = function (_Component) {
  inherits(MobileBanner, _Component);

  function MobileBanner(props) {
    classCallCheck(this, MobileBanner);

    var _this = possibleConstructorReturn(this, (MobileBanner.__proto__ || Object.getPrototypeOf(MobileBanner)).call(this, props));

    _this.starRatings = function (stars) {
      if (stars > 5 || stars < 0) {
        return React.createElement('div', {
          className: styles.rating
        }, React.createElement('span', null, "\u2606"), React.createElement('span', null, "\u2606"), React.createElement('span', null, "\u2606"), React.createElement('span', null, "\u2606"), React.createElement('span', null, "\u2606"));
      }

      var starsData = [];

      for (var i = 0; i < 5; i++) {
        var star = {};

        if (i < stars) {
          star['star'] = true;
        } else {
          star['star'] = false;
        }

        starsData.push(star);
      }

      return React.createElement('div', {
        className: styles.rating
      }, starsData.map(function (star, i) {
        if (star.star) {
          return React.createElement('span', {
            key: i,
            className: styles.activeStar
          }, "\u2606");
        }

        return React.createElement('span', {
          key: i
        }, "\u2606");
      }));
    };

    _this.state = {
      mobileBrowser: _this.getMobileOperatingSystem()
    };
    return _this;
  }

  createClass(MobileBanner, [{
    key: 'getMobileOperatingSystem',
    value: function getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/windows phone/i.test(userAgent)) {
        return "Windows";
      }

      if (/android/i.test(userAgent)) {
        return "Android";
      }

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
      }

      return "unknown";
    }
  }, {
    key: 'checkOsfeatures',
    value: function checkOsfeatures(Os) {
      var osObjects = {};
      var _props = this.props,
          price = _props.price,
          appId = _props.appId,
          storeText = _props.storeText;

      if (price[Os]) {
        osObjects.price = price[Os];
      } else {
        osObjects.price = 'FREE';
      }

      if (appId[Os]) {
        if (Os == 'android') {
          osObjects.url = 'http://play.google.com/store/apps/details?id=' + appId[Os];
        } else if (Os == 'ios') {
          osObjects.url = 'https://apps.apple.com/in/app/' + appId[Os];
        } else if (Os == 'ios') {
          osObjects.url = 'http://www.windowsphone.com/s?appid=' + appId[Os];
        }
      } else {
        osObjects.url = '';
      }

      if (storeText[Os]) {
        osObjects.storeText = storeText[Os];
      }

      return osObjects;
    }
  }, {
    key: 'getOsFunctions',
    value: function getOsFunctions() {
      var osInfo = {};

      if (this.state.mobileBrowser === 'Windows') {
        osInfo = this.checkOsfeatures('windows');
      } else if (this.state.mobileBrowser === 'Android') {
        osInfo = this.checkOsfeatures('android');
      } else if (this.state.mobileBrowser === 'iOS') {
        osInfo = this.checkOsfeatures('ios');
      }

      return osInfo;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var OS = this.getOsFunctions();
      var _props2 = this.props,
          showBanner = _props2.showBanner,
          backgroundColor = _props2.backgroundColor,
          onClose = _props2.onClose,
          appIcon = _props2.appIcon,
          appIconStyle = _props2.appIconStyle,
          appTitle = _props2.appTitle,
          appTitleStyles = _props2.appTitleStyles,
          appDescription = _props2.appDescription,
          topStickyBanner = _props2.topStickyBanner,
          position = _props2.position,
          buttonText = _props2.buttonText,
          buttonStyle = _props2.buttonStyle,
          closeButtonStyle = _props2.closeButtonStyle,
          starRating = _props2.starRating,
          starRatingCount = _props2.starRatingCount,
          onInstall = _props2.onInstall;
      var mobileBrowser = this.state.mobileBrowser;

      if (mobileBrowser && mobileBrowser == 'unknown' || !showBanner) {
        return React.createElement('div', null);
      }

      var positionClassName = "";

      if (position == 'bottom') {
        positionClassName = styles.bannerBottom;
      } else {
        positionClassName = styles.bannerTop;
      }

      if (topStickyBanner && position == 'top') {
        positionClassName = styles.bannerTop + ' ' + styles.bannerSticky;
      }

      return React.createElement('div', {
        className: positionClassName,
        style: {
          backgroundColor: backgroundColor
        }
      }, React.createElement('div', {
        className: styles.banner
      }, React.createElement('div', {
        className: styles.bannerClose
      }, React.createElement('div', {
        onClick: function onClick() {
          onClose();

          _this2.setState({
            mobileBrowser: 'unknown'
          });
        },
        style: closeButtonStyle
      }, "\u2716")), React.createElement('div', {
        className: styles.bannerImage
      }, React.createElement('img', {
        style: appIconStyle,
        className: styles.bannerIcon,
        src: appIcon
      })), React.createElement('div', {
        className: styles.bannerContents
      }, React.createElement('div', {
        className: styles.bannerTitle,
        style: appTitleStyles
      }, appTitle), React.createElement('div', {
        className: styles.bannerDescription
      }, appDescription), starRating && this.starRatings(starRatingCount), React.createElement('div', {
        className: styles.bannerStoreText
      }, OS.price + ' - ' + OS.storeText)), React.createElement('div', {
        className: styles.bannerButton
      }, React.createElement('a', {
        className: styles.bannerButtonText,
        onClick: function onClick() {
          return onInstall();
        },
        style: buttonStyle,
        type: 'button',
        target: OS.url != '' && "_blank",
        href: OS.url
      }, buttonText))));
    }
  }]);
  return MobileBanner;
}(Component);

MobileBanner.propTypes = {
  showBanner: PropTypes.bool,
  position: PropTypes.string,
  topStickyBanner: PropTypes.bool,
  backgroundColor: PropTypes.string,
  appId: PropTypes.objectOf(PropTypes.string),
  onClose: PropTypes.func,
  closeButtonStyle: PropTypes.objectOf(PropTypes.string),
  appIcon: PropTypes.string,
  appIconStyle: PropTypes.objectOf(PropTypes.string),
  appTitle: PropTypes.string,
  appTitleStyles: PropTypes.objectOf(PropTypes.string),
  appDescription: PropTypes.string,
  appDescriptionStyle: PropTypes.objectOf(PropTypes.string),
  starRatingCount: PropTypes.number,
  starRating: PropTypes.bool,
  price: PropTypes.objectOf(PropTypes.string),
  storeText: PropTypes.objectOf(PropTypes.string),
  buttonText: PropTypes.string,
  buttonStyle: PropTypes.objectOf(PropTypes.string),
  onInstall: PropTypes.func
};
MobileBanner.defaultProps = {
  showBanner: true,
  position: 'top',
  backgroundColor: 'green',
  topStickyBanner: false,
  appId: {
    ios: '',
    android: '',
    windows: ''
  },
  closeButtonStyle: {},
  onClose: function onClose() {},
  appIcon: '',
  appIconStyle: {},
  appTitle: 'App Title ',
  appTitleStyles: {},
  appDescription: 'App Descriptions .....',
  appDescriptionStyle: {},
  starRatingCount: 5,
  starRating: true,
  price: {
    ios: 'FREE',
    android: 'FREE',
    windows: 'FREE'
  },
  storeText: {
    ios: 'On the App Store',
    android: 'In Google Play',
    windows: 'In Windows Store'
  },
  buttonText: 'View',
  buttonStyle: {},
  onInstall: function onInstall() {}
};
export default MobileBanner;